<template>
    <scroll-area>
      <template slot="body">
        <v-layout column fill-height>
          <v-flex shrink pa-1>
            <v-checkbox :data-testid="$options.name + 'v-checkbox' + 'areas.show'" hide-details :label="$t('show areas')" v-model="areas.show"></v-checkbox>
            <v-flex shrink v-if="areas.show" pa-1>
              <v-select :data-testid="$options.name + 'v-select' + 'filter.locationTypes'"
                v-if="areas.show"
                v-model="filter.locationTypes"
                light
                :items="locationTypes"
                :label="$t('areas types')"
                :menu-props="{ maxHeight: '400' }"
                item-text="value"
                item-value="id"
                persistent-hint
                outline
                clearable
                class="white"
                background-color="white"
                hide-details
                dense
                flat
                multiple
              >
                <template v-slot:prepend-item>
                  <v-list-tile
                    ripple
                    @click="() => toggleTypes('locationTypes')"
                  >
                    <v-list-tile-action>
                      <v-icon :color="filter.locationTypes.length > 0 ? 'indigo darken-4' : ''">{{ getIconTypes('locationTypes') }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title v-if="!filter.locationTypes.length">{{ $t('select all') }}</v-list-tile-title>
                      <v-list-tile-title v-if="filter.locationTypes.length && filter.locationTypes.length < locationTypes.length">{{ $t('select all') }}</v-list-tile-title>
                      <v-list-tile-title v-if="filter.locationTypes.length == locationTypes.length">{{ $t('unselect all') }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:item="{ item, index }">
                  <span>{{ $t(String(item)) }}</span>
                </template>
                <template v-slot:selection="{ item, index }">
                  <span>{{ $t(String(item)) }}, </span>
                </template>
              </v-select>
            </v-flex>

            <v-flex shrink v-if="areas.show" pa-1>
              <v-select :data-testid="$options.name + 'v-select' + 'filter.locations'"
                v-if="areas.show"
                v-model="filter.locations"
                light
                :items="getAreas"
                :label="$t('locations')"
                :menu-props="{ maxHeight: '400' }"
                item-text="name"
                item-value="$id"
                persistent-hint
                outline
                clearable
                class="white"
                background-color="white"
                hide-details
                dense
                flat
                multiple
              >
                <template v-slot:item="{ item, index }">
                  <span>{{ $t(String(item.name)) }}</span>
                </template>
                <template v-slot:selection="{ item, index }">
                  <span>{{ $t(String(item.name)) }}, </span>
                </template>
              </v-select>
            </v-flex>

            <v-checkbox :data-testid="$options.name + 'v-checkbox' + 'objects.show'" hide-details :label="$t('show objects')" v-model="objects.show"></v-checkbox>
            <v-flex shrink v-if="objects.show" pa-1>
              <v-select :data-testid="$options.name + 'v-select' + 'filter.objectTypes'"
                v-if="objects.show"
                v-model="filter.objectTypes"
                light
                :items="objectTypes"
                :label="$t('objects types')"
                :menu-props="{ maxHeight: '400' }"
                item-text="value"
                item-value="id"
                persistent-hint
                outline
                clearable
                class="white"
                background-color="white"
                hide-details
                dense
                flat
                multiple
              >
                <template v-slot:prepend-item>
                  <v-list-tile
                    ripple
                    @click="() => toggleTypes('objectTypes')"
                  >
                    <v-list-tile-action>
                      <v-icon :color="filter.objectTypes.length > 0 ? 'indigo darken-4' : ''">{{ getIconTypes('objectTypes') }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title v-if="!filter.objectTypes.length">{{ $t('select all') }}</v-list-tile-title>
                      <v-list-tile-title v-if="filter.objectTypes.length && filter.objectTypes.length < objectTypes.length">{{ $t('select all') }}</v-list-tile-title>
                      <v-list-tile-title v-if="filter.objectTypes.length == objectTypes.length">{{ $t('unselect all') }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:item="{ item, index }">
                  <span>{{ $t(String(item)) }}</span>
                </template>
                <template v-slot:selection="{ item, index }">
                  <span>{{ $t(String(item)) }}, </span>
                </template>
              </v-select>
            </v-flex>

            <v-flex shrink v-if="objects.show" pa-1>
              <v-select :data-testid="$options.name + 'v-select' + 'filter.conditionTypes'"
                v-if="objects.show"
                v-model="filter.conditionTypes"
                light
                :items="conditionTypes"
                :label="$t('condition_type')"
                :menu-props="{ maxHeight: '400' }"
                item-text="value"
                item-value="id"
                persistent-hint
                outline
                clearable
                class="white"
                background-color="white"
                hide-details
                dense
                flat
                multiple
              >
                <template v-slot:item="{ item, index }">
                  <span>{{ $t(String(item.value)) }}</span>
                </template>
                <template v-slot:selection="{ item, index }">
                  <span>{{ $t(String(item.value)) }}, </span>
                </template>
              </v-select>
            </v-flex>

            <v-checkbox :data-testid="$options.name + 'v-checkbox' + 'connections.show'" hide-details :label="$t('show connections')" v-model="connections.show"></v-checkbox>

            <v-flex shrink pa-1>
              <v-select :data-testid="$options.name + 'v-select' + 'connections.filter.type'"
                v-if="connections.show"
                v-model="connections.filter.type"
                light
                :items="connectionTypes"
                :label="$t('connection types')"
                :menu-props="{ maxHeight: '400' }"
                item-text="value"
                item-value="id"
                persistent-hint
                outline
                clearable
                class="white"
                background-color="white"
                hide-details
                dense
                flat
                multiple
              >
                <template v-slot:prepend-item>
                  <v-list-tile
                    ripple
                    @click="() => toggleTypes('connectionTypes')"
                  >
                    <v-list-tile-action>
                      <v-icon :color="connections.filter.type.length > 0 ? 'indigo darken-4' : ''">{{ getIconTypes('connectionTypes') }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title v-if="!connections.filter.type.length">{{ $t('select all') }}</v-list-tile-title>
                      <v-list-tile-title v-if="connections.filter.type.length && (connections.filter.type.length < connectionTypes.length)">{{ $t('select all') }}</v-list-tile-title>
                      <v-list-tile-title v-if="connections.filter.type.length == connectionTypes.length">{{ $t('unselect all') }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>
            </v-flex>

            <v-flex shrink v-if="connections.filter.type.length" pa-1>
              <v-layout fill-height align-center>
                <v-select :data-testid="$options.name + 'v-select' + 'selectedConnections'"
                  v-model="selectedConnections"
                  light
                  :items="getConnections"
                  :label="$t('connections')"
                  :menu-props="{ maxHeight: '400' }"
                  item-text="name"
                  return-object
                  outline
                  clearable
                  :no-data-text="$t('no connections of this type')"
                  class="white"
                  background-color="white"
                  hide-details
                  dense
                  flat
                  multiple
                >
                  <template v-slot:prepend-item>
                    <v-list-tile
                      ripple
                      @click="toggleConnection"
                    >
                      <v-list-tile-action>
                        <v-icon :color="selectedConnections.length > 0 ? 'indigo darken-4' : ''">{{ iconConnections }}</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title v-if="!selectedConnections.length">{{ $t('select all') }}</v-list-tile-title>
                        <v-list-tile-title v-if="selectedConnections.length && selectedConnections.length < getConnections.length">{{ $t('select all') }}</v-list-tile-title>
                        <v-list-tile-title v-if="selectedConnections.length == getConnections.length">{{ $t('unselect all') }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </v-layout>
            </v-flex>
          </v-flex>
        </v-layout>
      </template>
    </scroll-area>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'

// Типы для фильтров
interface FilterState {
  connectionTypes: any[]
  channelTypes: any[]
  locationTypes: string[]
  locationSubtypes: any[]
  locations: any[]
  objectTypes: string[]
  objectSubtypes: any[]
  conditionTypes: any[]
}

interface ConnectionFilter {
  type: any[]
}

interface ConnectionsState {
  items: any[]
  filter: ConnectionFilter
  show: boolean
  selectedConnections?: any[]
}

interface ChannelsState {
  items: any[]
  filter: ConnectionFilter
  show: boolean
  selectedChannels?: any[]
}

interface AreasState {
  items: any[]
  show: boolean
}

interface ObjectsState {
  items: any[]
  show: boolean
  labels?: boolean
}

interface ComponentData {
  areas: AreasState
  objects: ObjectsState
  connections: ConnectionsState
  channels: ChannelsState
  filter: FilterState
  connectionTypes: any[]
  channelTypes: any[]
  locationTypes: string[]
  objectTypes: string[]
  objectSubtypes: any[]
  conditionTypes: any[]
  locationSubtypes: any[]
  locations: any[]
  selectedConnections: any[]
  selectedChannels: any[]
  connectionsShow?: boolean
}

interface ConnectionItem {
  template?: string
  $id?: string
  [key: string]: any
}

interface ChannelItem {
  type?: { id?: string }
  $id?: string
  [key: string]: any
}

interface AreaItem {
  type?: string
  [key: string]: any
}

export default Vue.extend({
  name: 'MAP_SIDEBAR',

  components: {
    scrollArea,
  },

  props: {
    type: {
      type: Number,
      default: () => 1
    },
  },

  data(): ComponentData {
    return {
      areas: {
        items: [],
        show: false,
      },
      objects: {
        items: [],
        show: true,
        labels: true,
      },
      connections: {
        items: [],
        filter: { type: [] },
        show: false,
        selectedConnections: [],
      },
      channels: {
        items: [],
        filter: { type: [] },
        show: false,
        selectedChannels: [],
      },
      filter: {
        connectionTypes: [],
        channelTypes: [],
        locationTypes: [],
        locationSubtypes: [],
        locations: [],
        objectTypes: ['facility', 'building'],
        objectSubtypes: [],
        conditionTypes: []
      },
      connectionTypes: [],
      channelTypes: [],
      locationTypes: ['zone', 'subzone'],
      objectTypes: ['facility', 'building'],
      objectSubtypes: [],
      conditionTypes: [],
      locationSubtypes: [],
      locations: [],
      selectedConnections: [],
      selectedChannels: [],
    }
  },

  computed: {
    iconConnections(): string {
      const selectedLen = this.selectedConnections?.length || 0
      const connectionsLen = this.getConnections?.length || 0
      
      if (selectedLen && selectedLen < connectionsLen) return 'mdi-minus-box'
      if (selectedLen === connectionsLen) return 'mdi-close-box'
      return 'mdi-checkbox-blank-outline'
    },

    getAreas(): AreaItem[] {
      return this.$store.state.topology.areas.filter((area: AreaItem) => {
        return this.filter.locationTypes.includes(area.type || '')
      })
    },

    getConnections(): ConnectionItem[] {
      return this.$store.getters.getConnections.filter((connection: ConnectionItem) => {
        return this.connections.filter.type.some((type: any) => type === connection.template)
      })
    },

    getChannels(): ChannelItem[] {
      return this.$store.state.topology.channels.filter((channel: ChannelItem) => {
        return this.channels.filter.type.some((type: any) => type.id === channel.type?.id)
      })
    },
  },

  watch: {
    'areas.show': {
      handler(newVal: boolean): void {
        console.log('WATCH', this.$options.name, 'areas show', newVal)
        console.log('WATCH', this.$options.name, 'areas show', 'filter', this.filter)
        this.$store.dispatch('showAreas', newVal)
      }
    },

    'objects.show': {
      handler(newVal: boolean): void {
        if (!newVal) {
          this.$set(this.filter, 'objectTypes', [])
        }
        console.log('WATCH', this.$options.name, 'objects show', newVal)
      }
    },

    'connections.show': {
      handler(newVal: boolean): void {
        this.$store.dispatch('showConnections', newVal)
      }
    },

    'channels.show': {
      handler(newVal: boolean): void {
        this.$store.dispatch('showSelectedChannels', newVal)
      }
    },

    type: {
      handler(newVal: number): void {
        if (newVal === 1) {
          this.connectionsShow = true
        } else {
          this.reset()
        }
      }
    },

    'channels.filter.type': {
      handler(newVal: any[]): void {
        console.log('WATCH', this.$options.name, 'MAP_SIDEBAR', 'channels.filter.type', newVal)
        if (!newVal.length) {
          this.selectedChannels = []
        }
      },
      deep: true
    },

    'connections.filter.type': {
      handler(newVal: any[]): void {
        if (!newVal.length) {
          this.selectedConnections = []
        }
      },
      deep: true
    },

    filter: {
      handler(newVal: FilterState): void {
        console.log('WATCH', this.$options.name, 'MAP_SIDEBAR', 'filter', newVal)
        this.$store.dispatch('applyTopologyFilter', newVal)
      },
      deep: true
    },

    selectedChannels: {
      handler(newVal: any[]): void {
        console.log('WATCH', this.$options.name, 'MAP_SIDEBAR', 'selectedChannels', newVal)
        this.$store.dispatch('showSelectedChannels', newVal)
      },
      deep: true
    },

    selectedConnections: {
      handler(newVal: any[]): void {
        this.$store.dispatch('showSelectedConnections', newVal)
      },
      deep: true
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(): Promise<void> {
      this.reset()
      await this.loadConnectionTypes()
      await this.loadChannelTypes()
      await this.loadConditionTypes()
      await this.loadObjectSubtypes()
      await this.loadLocations()
      this.$store.dispatch('loadChannels')
    },

    toggleTypes(type: string): void {
      if (type === 'channelTypes') {
        this.$nextTick(() => {
          if (this.channels.filter.type.length === this.channelTypes.length) {
            this.$set(this.channels.filter, 'type', [])
          } else {
            this.$set(this.channels.filter, 'type', [])
            this.channelTypes.forEach((typeItem: any, index: number) => {
              this.$set(this.channels.filter.type, index, typeItem)
            })
          }
        })
      } else if (type === 'connectionTypes') {
        this.$nextTick(() => {
          if (this.connections.filter.type.length === this.connectionTypes.length) {
            this.$set(this.connections.filter, 'type', [])
          } else {
            this.$set(this.connections.filter, 'type', [])
            this.connectionTypes.forEach((typeItem: any, index: number) => {
              this.$set(this.connections.filter.type, index, typeItem)
            })
          }
        })
      } else {
        this.$nextTick(() => {
          const filterKey = type as keyof FilterState
          const filterArray = this.filter[filterKey] as any[]
          const typeArray = this[type as keyof ComponentData] as any[]
          
          if (filterArray?.length === typeArray?.length) {
            this.$set(this.filter, filterKey, [])
          } else {
            console.log('toggleTypes ELSE ELSE', typeArray)
            this.$set(this.filter, filterKey, [])
            typeArray?.forEach((typeItem: any, index: number) => {
              ;(this.filter[filterKey] as any[]).push(typeItem)
            })
          }
        })
      }
    },

    toggleConnection(): void {
      this.$nextTick(() => {
        if (this.selectedConnections.length === this.getConnections.length) {
          this.selectedConnections = []
        } else {
          this.selectedConnections = this.$merge([], this.getConnections)
        }
      })
    },

    loadConnectionTypes(): void {
      this.$store.getters.getConnections.forEach((connection: ConnectionItem) => {
        if (connection.template && !this.connectionTypes.includes(connection.template)) {
          this.connectionTypes.push(connection.template)
        }
      })
    },

    async loadChannelTypes(): Promise<void> {
      try {
        const channelTypes = await this.$bridge.getEnum('channel')
        if (channelTypes) {
          this.channelTypes = channelTypes
        } else {
          console.log(this.$options.name, 'loadChannelTypes', 'smth wrong', channelTypes)
        }
      } catch (err) {
        console.log('CATCH', 'MAP_SIDEBAR', 'loadChannelTypes', err)
      }
    },

    async loadLocations(): Promise<void> {
      this.locations = this.$store.state.topology.areas
      console.log(this.$options.name, 'loadLocations', 'locations', this.locations)
    },

    async loadConditionTypes(): Promise<void> {
      try {
        const conditionTypes = await this.$bridge.getEnum('condition_type')
        if (conditionTypes) {
          console.log(this.$options.name, 'loadConditionTypes', 'conditionTypes', conditionTypes)
          this.conditionTypes = conditionTypes
        } else {
          console.log(this.$options.name, 'loadConditionTypes', 'smth wrong', conditionTypes)
        }
      } catch (err) {
        console.log('CATCH', 'MAP_SIDEBAR', 'loadConditionTypes', err)
      }
    },

    async loadObjectSubtypes(): Promise<void> {
      try {
        const subtypes = await this.$bridge.getEnum('location_type')
        if (subtypes) {
          console.log(this.$options.name, 'loadObjectSubtypes', 'subtypes', subtypes)
          this.objectSubtypes = subtypes
        } else {
          console.log(this.$options.name, 'loadObjectSubtypes', 'smth wrong', subtypes)
        }
      } catch (err) {
        console.log('CATCH', 'MAP_SIDEBAR', 'loadObjectSubtypes', err)
      }
    },

    getIconTypes(type: string): string {
      const filterKey = type as keyof FilterState
      const filterArray = this.filter[filterKey] as any[]
      const typeArray = this[type as keyof ComponentData] as any[]
      
      if (filterArray?.length && filterArray.length < typeArray?.length) return 'mdi-minus-box'
      if (filterArray?.length === typeArray?.length) return 'mdi-close-box'
      return 'mdi-checkbox-blank-outline'
    },

    reset(): void {
      this.areas = {
        items: [],
        show: false,
      }
      this.objects = {
        items: [],
        show: true,
      }
      this.connections = {
        items: [],
        filter: { type: [] },
        show: false,
        selectedConnections: [],
      }
      this.channels = {
        items: [],
        filter: { type: [] },
        show: false,
        selectedChannels: [],
      }
      this.filter = {
        connectionTypes: [],
        channelTypes: [],
        locationTypes: [],
        locationSubtypes: [],
        locations: [],
        objectTypes: ['facility', 'building'],
        objectSubtypes: [],
        conditionTypes: []
      }
      this.connectionTypes = []
      this.channelTypes = []
      this.locationTypes = ['zone', 'subzone']
      this.objectTypes = ['facility', 'building']
      this.objectSubtypes = []
      this.conditionTypes = []
      this.locationSubtypes = []
      this.locations = []
      this.selectedConnections = []
      this.selectedChannels = []
      this.connectionsShow = false
    },

    showSelected(): void {
      console.log(this.$options.name, 'showSelected', this.selectedChannels)
      this.$store.dispatch('showSelectedChannels', this.selectedChannels)
    },
  },
})
</script>

<style lang="css" scoped>
</style>
